import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import { TERRAINS_PENDING, TERRAINS_SUCCESS, TERRAINS_ERROR } from '../types';

export const getTerrains = () => async (dispatch, getState) => {
  const terrainsStatus = getState().terrains.status;

  // If more than one component calls the same feed make sure we only make one request
  if (terrainsStatus !== FetchStatus.LOADING && terrainsStatus !== FetchStatus.PENDING) {
    try {
      dispatch({
        type: TERRAINS_PENDING,
        payload: [],
      });
      const res = await axios.get(`${getNodeApiDomain()}/dor/drupal/terrains`);
      dispatch({
        type: TERRAINS_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: TERRAINS_ERROR,
        payload: error,
      });
    }
  }
};
